(() => {
  angular
    .module('app.core')
    .factory('QualityMetricsService', QualityMetricsService);

  QualityMetricsService.$inject = ['$resource'];

  function QualityMetricsService($resource) {
    const qualityMetricsResource = $resource('/qualitymetrics/:action');
    const campaignAttributeResource = $resource('/campaignattribute/:action');

    return {
      getAvailableQualityMetrics: () => qualityMetricsResource
        .get({
          action: 'query'
        }).$promise,

      getQualityMetricsScore: id => campaignAttributeResource
        .get({
          id,
          action: 'query',
          attribute: 'qualityMetrics'
        }).$promise
    }
  }
})();
